import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import appointmentsReducer from '../features/appointments/appointmentsSlice';
import servicesReducer from '../features/services/servicesSlice';
import teamMembersReducer from '../features/team-members/teamMembersSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    appointments: appointmentsReducer,
    services: servicesReducer,
    teamMembers: teamMembersReducer,
  },
});
